import { Observable } from 'rxjs';

let previousUrl = '';

export const urlChanges$ = new Observable((observer) => {
  const mutationObserver = new MutationObserver(() => {
    if (window.parent.location.href !== previousUrl) {
      previousUrl = window.parent.location.href;
      observer.next(window.parent.location.href);
    }
  });
  const config = { childList: true, subtree: true };
  mutationObserver.observe(window.parent.document, config);
  return () => {
    mutationObserver.disconnect();
  };
});
